import { useQuery } from 'react-query'

import kilometres from '../../../assets/carPin.png'
import MainInfoUsage from "../MainInfoUsage/MainInfoUsage";

export default function KilometresUsage() {
    const { data } = useQuery('getContractInfo')

    return (
        <MainInfoUsage
            myCardTitle='Χιλιόμετρα που έχεις διανύσει'
            ImageWidth={280}
            ImageSrc={kilometres}
            fontSize={25}
            TextOverImageInfo={`${data.kilometers}km`}
            TextInfo={`Έχεις καταναλώσει ${data.kilometers}  χιλιόμετρα από τα συνολικά σου χιλιόμετρα.`}
            borderRadiusInfo={10}
            transform=' translate(90%,290%)'
        />
    )
}


